import React, { useEffect, useRef, useState } from "react";
import NewLoader from "../reusedElements/NewLoader";
import { Button, Container } from "reactstrap";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { reactivateSubscription } from "../services/paymentService";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import { showMessagePayment, stripeAppearance } from "../commonutilities";
import { website_url } from "../bootapi";
import { supabase } from "..";

const CheckoutForm = ({
  paymentMethod,
  clientSecret,
  toggleLoader,
  updateStateOfThreeD,
  toggleCancel,
}) => {
  /*This functional component is basically for cards which require 3d authentication while updating*/
  const stripe = useStripe();

  useEffect(() => {
    if (clientSecret && stripe) {
      stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        switch (paymentIntent.status) {
          case "succeeded":
            showMessagePayment("Reactivation succeeded!", "success");
            // setMessage("Payment succeeded!");
            toggleCancel();
            break;
          case "processing":
            showMessagePayment(
              "Please wait your reactivation is processing.",
              "success"
            );
            // setMessage("Your payment is processing.");
            break;
          case "requires_payment_method":
            showMessagePayment(
              "Your reactivation was not unsuccessful, please try again.",
              "error"
            );
            toggleCancel();
            // setMessage("Your payment was not successful, please try again.");
            break;
          case "requires_action" || "requires_source_action":
            break;

          default:
            showMessagePayment("Something went wrong.", "error");
            // setMessage("Something went wrong.");
            toggleCancel();
            break;
        }
      });
      stripe
        .confirmPayment({
          payment_method: paymentMethod,
          clientSecret,
          redirect: "if_required",
          confirmParams: {
            // return_url: `http://localhost:3000/auth/account_subscription`,
            return_url: `${website_url}/`,
          },
        })
        .then(function (result) {
          // console.log("result:", result.error.code);
          if (result.error) {
            // Handle errors
            // User canceled 3D Secure authentication
            if (result.error.code) {
              showMessagePayment(`${result.error.message}`, "error");
              toggleCancel();
            }
            // else if(result.error.c)
            // console.error(result.error.message);
          } else {
            // Handle success or next action
            if (
              result.paymentIntent.status === "requires_action" ||
              result.paymentIntent.status === "requires_source_action"
            ) {
              // Handle the next action (e.g., 3DS authentication)
              // console.log("success.......87");
              handleNextAction(result.paymentIntent.client_secret);
            } else {
              toggleLoader();
              // Payment succeeded
              // handlePaymentSuccess(result.paymentIntent);
            }
          }
        });
    }
  }, [clientSecret, stripe]);
  function handleNextAction(clientSecret) {
    stripe.handleCardAction(clientSecret).then(function (confirmResult) {
      // console.log("result:.......100", confirmResult);
      if (confirmResult.error) {
        toggleCancel();
        // Handle errors during next action
        // console.error(confirmResult.error.message);
      } else {
        // console.log("success.......103");
        // Next action (e.g., 3DS authentication) successful, confirm the payment again
        confirmPaymentAfterNextAction(clientSecret);
      }
    });
  }
  function confirmPaymentAfterNextAction(clientSecret) {
    stripe
      .confirmCardPayment(clientSecret, {
        payment_method: paymentMethod,
      })
      .then(function (confirmResult) {
        // console.log("result:.......117", confirmResult);
        if (confirmResult.error) {
          toggleCancel();
          // Handle errors after next action
          // console.error(confirmResult.error.message);
        } else {
          toggleLoader();
          // console.log("success.......120");
          // Handle success or additional actions if needed
          // handlePaymentSuccess(confirmResult.paymentIntent);
        }
      });
  }

  return <div></div>;
};

const Reactivation = (args) => {
  const history = useNavigate();
  const [loader, setLoader] = useState(false);
  let messagesEndRef = useRef(null);
  const location = useLocation();
  const { user_id, subscription_id } = useParams();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [showform, setshowform] = useState(false);
  const [stripepromise, setstripepromise] = useState();
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [options, setoptions] = useState({});

  const scrollToTop = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  useEffect(() => {
    if (user_id && subscription_id) {
      setLoader(true);
      let reactivationData = {
        user_id: user_id,
        subscription_id,
      };
      const fetchUser = async () => {
        const { data } = await supabase.auth.getSession();
        if (!data?.session?.user) return;
        reactivateSubscription(
          JSON.stringify(reactivationData),
          data?.session?.access_token
        )
          .then((res) => {
            if (res?.data?.client_secret) {
              setshowform(true);
              setstripepromise(loadStripe(res?.data?.publishableKey));
              setClientSecret(res?.data?.client_secret);
              setPaymentMethod(res?.data?.payment_method);
              setoptions({
                clientSecret: res?.data?.client_secret,
                appearance: stripeAppearance,
              });
            } else {
              setLoader(false);
              setSuccess(true);
            }
          })
          .catch((err) => {
            //   console.log(err?.response?.data?.status_code);
            setLoader(false);
            setSuccess(false);
            setError(err?.response?.data?.status_code);
          });
      };
      fetchUser();
    }
  }, [user_id, subscription_id]);
  const toggleLoader = () => {
    setLoader(false);
    setSuccess(true);
  };
  const toggleCancel = () => {
    setLoader(false);
    setError(true);
  };

  return (
    <React.StrictMode>
      {loader && <NewLoader />}
      {showform && clientSecret && (
        <div
          // ref={messagesEndRef}
          className="container"
          style={{ marginTop: "100px" }}
        >
          <Elements
            stripe={stripepromise}
            options={options}
            paymentMethod={paymentMethod}
            clientSecret={clientSecret}
          >
            <CheckoutForm
              paymentMethod={paymentMethod}
              clientSecret={clientSecret}
              toggleLoader={toggleLoader}
              toggleCancel={toggleCancel}
            />
          </Elements>
        </div>
      )}
      <div
        onClick={() => {
          args.toggleMenu();
        }}
        ref={messagesEndRef}
      >
        <div className="hero-main form-hero-main">
          <Container></Container>
        </div>
      </div>
      <div className="mod-wrapper" />

      {error && error === 400 && (
        <div className="mod-wrapper">
          <div className="mod-container ">
            <div className="flexColCenter rg-1 mod-header-settings-backup">
              <img
                className="icon-36 mb-4"
                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-sad.png?t=2024-01-09T17%3A29%3A35.687Z"
                alt=""
              />
              <h2 className="textCenter">OOPS!</h2>
            </div>
            <div className="textCenter">
              <p>
                Your subscription is already active.If you believe there's an
                issue, please contact support for assistance.
              </p>
              <Button color="primary" onClick={() => history(`/contactus`)}>
                Contact Support
              </Button>
            </div>
          </div>
        </div>
      )}
      {error && error === 403 && (
        <div className="mod-wrapper">
          <div className="mod-container ">
            <div className="flexColCenter rg-1 mod-header-settings-backup">
              <img
                className="icon-36 mb-4"
                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/emoji-sad.png?t=2024-01-09T17%3A29%3A35.687Z"
                alt=""
              />
              <h2 className="textCenter">OOPS!</h2>
            </div>
            <div className="textCenter">
              <p>
                Subscription not found.If you believe there's an issue, please
                contact support for assistance.
              </p>
              <Button color="primary" onClick={() => history(`/contactus`)}>
                Contact Support
              </Button>
            </div>
          </div>
        </div>
      )}
      {success && (
        <div className="mod-wrapper">
          <div className="mod-container ">
            <div className="flexColCenter rg-1 mod-header-settings-backup">
              <img
                className="icon-36"
                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/CheckedImage.png?t=2024-01-09T11%3A07%3A29.460Z"
                alt=""
              />
              <h2 className="textCenter">Reactivated!</h2>
            </div>
            <div className="textCenter">
              <p>
                Welcome back! Your subscription to <b>SeventhSight</b> is now
                reactivated. We want to express our gratitude for your continued
                support and trust in us. With your subscription, you regain
                access to a wealth of premium features and exclusive content.
              </p>
              <Button color="primary" onClick={() => history(`/`)}>
                Continue Exploring
              </Button>
            </div>
          </div>
        </div>
      )}
    </React.StrictMode>
  );
};

export default Reactivation;
